(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["megachip-vehicle-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('megachip-finder')) {
  customElements.define('megachip-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.cards = Array.from(this.querySelectorAll('[data-vehicle]'));
      this.make = this.querySelector('select[data-make]');
      this.search = this.querySelector('input[data-search]');
      this.more = this.querySelector('[data-show-all]');
      this.results = this.querySelector('[data-results]');
      this.expanded = false;
      Array.from(new Set(this.cards.flatMap(c => c.dataset.make.split(' / ')))).sort().forEach(make => {
        const o = document.createElement('option');o.value = make;o.textContent = make;this.make.append(o);
      });
      this.querySelector('.mc-filters').hidden = false;
      this.results.hidden = false;
      this.make.addEventListener('change', () => this.update());
      this.search.addEventListener('input', () => this.update());
      this.querySelector('[data-reset]').addEventListener('click', () => {this.make.value='';this.search.value='';this.expanded=false;this.update();this.make.focus();});
      this.more.addEventListener('click', () => {this.expanded=true;this.update();this.cards[6]?.querySelector('a')?.focus();});
      this.update();
    }
    update() {
      const terms=this.search.value.toLowerCase().trim().split(/\s+/).filter(Boolean);
      const filtered=this.cards.filter(c => (!this.make.value || c.dataset.make.split(' / ').includes(this.make.value)) && terms.every(t=>c.dataset.search.toLowerCase().includes(t)));
      const limit=(this.expanded || this.make.value || terms.length) ? filtered.length : 6;
      const shown=filtered.slice(0,limit);
      this.cards.forEach(c=>c.hidden=!shown.includes(c));
      this.more.hidden=shown.length>=filtered.length;
      this.querySelector('[data-empty]').hidden=filtered.length>0;
      this.results.textContent=this.results.dataset.template.replace('[shown]',shown.length).replace('[total]',filtered.length);
    }
  });
  document.addEventListener('shopify:block:select', e => {
    const card=e.target.closest('[data-vehicle]');const finder=card?.closest('megachip-finder');
    if(finder){finder.make.value='';finder.search.value='';finder.expanded=true;finder.update();card.scrollIntoView({block:'center'});}
  });
}

  } catch(e) { console.error(e); }
})();
})();
